import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    LineController,
    LineElement,
    Title,
    Tooltip,
    PointElement,
    Legend
} from "chart.js";
import { useEffect, useState } from "react";
import "./Analytics.css";
import AnalyticsService from "../../../../services/analytics/AnalyticsService";
import Drawer from "antd/lib/drawer";
import { DRAWER_PLACEMENTS } from "../../../../config/constants";
import { Button, Select } from "antd";
import Datatable from "../../../shared/components/Datatable";

ChartJS.register(
    Title,
    Tooltip,
    PointElement,
    Legend,
    CategoryScale,
    LinearScale,
    LineController,
    LineElement,
);

function Analytics() {
    const [amountOfTables, setAmountOfTables] = useState([]);
    const [sizeOfDatabase, setSizeOfDatabase] = useState([]);
    const [amountOfBatchProcessing, setAmountOfBatchProcessing] = useState([]);
    const [numberOfEntities, setNumberOfEntities] = useState([]);
    const [numberOfGroupCodes, setNumberOfGroupCodes] = useState([]);
    const [activeUsersCount, setActiveUsersCount] = useState([]);
    const [numberOfEnvironments, setNumberOfEnvironments] = useState([]);
    const [numberOfExecutions, setNumberOfExecutions] = useState([]);
    const [numberOfLogicalReadWrites, setNumberOfLogicalReadWrites] = useState([]);
    const [cpuTime, setCpuTime] = useState([]);
    const [duration, setDuration] = useState([]);
    const [labels, setLabels] = useState([]);
    const [uniqueDatabaseNames, setUniqueDatabasesNames] = useState(new Set());
    const [analitycsType, setAnalyticsType] = useState("All databases")
    const [openDrawer, setOpenDrawer] = useState(false);
    const [drawerTable, setDrawerTable] = useState([]);
    const [data, setData] = useState([]);
    useEffect(() => {
        AnalyticsService.get(31).then((response: any) => {
            let data = response.data;
            data = data.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));
            setData(data);
            for (let row of data) {
                setAmountOfTables(prev => [...prev, row.databaseTableCount]);
                setSizeOfDatabase(prev => [...prev, row.databaseSizeBytes]);
                setAmountOfBatchProcessing(prev => [...prev, row.batchProcessingJobsCount]);
                setNumberOfEntities(prev => [...prev, row.entitiesCount]);
                setNumberOfGroupCodes(prev => [...prev, row.groupCodesCount]);
                setActiveUsersCount(prev => [...prev, row.activeUsersCount]);
                setNumberOfEnvironments(prev => [...prev, row.environmentsCount]);
                setNumberOfExecutions(prev => [...prev, row.queryExecutionsCount]);
                setNumberOfLogicalReadWrites(prev => [...prev, row.totalLogicalWrites]);
                setCpuTime(prev => [...prev, row.totalCpuTimeMs]);
                setDuration(prev => [...prev, row.totalElapsedTimeMs]);
                setLabels(prev => [...prev, new Date(row.createdAt).toDateString()]);
                uniqueDatabaseNames.add(row.databaseName)
            }
            setUniqueDatabasesNames(uniqueDatabaseNames);

        });
        return () => {
            setAmountOfTables([])
            setSizeOfDatabase([])
            setAmountOfBatchProcessing([])
            setNumberOfEntities([])
            setNumberOfGroupCodes([])
            setActiveUsersCount([])
            setNumberOfEnvironments([])
            setNumberOfExecutions([])
            setNumberOfLogicalReadWrites([])
            setCpuTime([])
            setDuration([])
            setLabels([])
        };
    }, []);
    const onClose = () => {
        setOpenDrawer(false);
        setDrawerTable([]);
    };

    const handleButtonClick = (key: string) => {
        AnalyticsService.get(10000).then((response: any) => {
            let data = response.data;
            data = data.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));
            let arrOfObj = [];
            for (let row of data) {
                let newObj = {
                    createdAt: new Date(row.createdAt).toLocaleDateString(),
                    secondRow: row[key]
                }
                arrOfObj.push(newObj);
            }
            setDrawerTable(arrOfObj);
        })
        setOpenDrawer(true)
    }
    const handleAnalitycsTypeChange = (input: string) => {
        setAnalyticsType(input)
    }
    useEffect(() => {
        let filteredData = data;
        if (analitycsType !== "All") {
            filteredData = filteredData.filter(a => a.databaseName === analitycsType);
        }
        for (let row of filteredData) {
            console.log("koliko puta udemn u petlju; ", row)
            setAmountOfTables(prev => [...prev, row.databaseTableCount]);
            setSizeOfDatabase(prev => [...prev, row.databaseSizeBytes]);
            setAmountOfBatchProcessing(prev => [...prev, row.batchProcessingJobsCount]);
            setNumberOfEntities(prev => [...prev, row.entitiesCount]);
            setNumberOfGroupCodes(prev => [...prev, row.groupCodesCount]);
            setActiveUsersCount(prev => [...prev, row.activeUsersCount]);
            setNumberOfEnvironments(prev => [...prev, row.environmentsCount]);
            setNumberOfExecutions(prev => [...prev, row.queryExecutionsCount]);
            setNumberOfLogicalReadWrites(prev => [...prev, row.totalLogicalWrites]);
            setCpuTime(prev => [...prev, row.totalCpuTimeMs]);
            setDuration(prev => [...prev, row.totalElapsedTimeMs]);
            setLabels(prev => [...prev, new Date(row.createdAt).toDateString()]);
            uniqueDatabaseNames.add(row.databaseName)
        }
        setUniqueDatabasesNames(uniqueDatabaseNames);

        return () => {
            setAmountOfTables([])
            setSizeOfDatabase([])
            setAmountOfBatchProcessing([])
            setNumberOfEntities([])
            setNumberOfGroupCodes([])
            setActiveUsersCount([])
            setNumberOfEnvironments([])
            setNumberOfExecutions([])
            setNumberOfLogicalReadWrites([])
            setCpuTime([])
            setDuration([])
            setLabels([])
        };
    }, [analitycsType]);
    const columns = [
        {
            title: "Created at",
            dataIndex: "createdAt",
            key: "createdAt",
            filters: [],
            filterMode: "tree",
        },
        {
            title: "Value",
            dataIndex: "secondRow",
            key: "secondRow",
            filters: [],
            filterMode: "tree",
        }
    ]

    const analitycsDropdown = [
        "All databases", ...uniqueDatabaseNames
    ]
    const scroll = { y: "calc(70vh - 10em)" };
    return (
        <div className="analytics-page">
            <div className="margin-bottom-30">
                <div>Display analytics for:</div>
                <Select
                    allowClear
                    placeholder="Select database"
                    value={analitycsType}
                    onChange={handleAnalitycsTypeChange}
                    options={analitycsDropdown.map((option) => ({
                        value: option, label: option
                    }))}
                    disabled={false}
                    className="w-100"
                />
            </div>
            <div className="display-flex-row margin-bottom-30">
                <div className="flex-item">
                    <div className="display-flex-row padding-right-15">
                        <b>Total amount of tables</b>
                        <Button onClick={() => handleButtonClick("databaseTableCount")}>Details</Button>
                    </div>
                    <Line
                        data={
                            {
                                labels: [...labels],
                                datasets: [
                                    {
                                        label: 'Amount of tables',
                                        backgroundColor: '#18145c',
                                        borderColor: '#18145c',
                                        borderWidth: 1,
                                        data: [...amountOfTables]
                                    },
                                ],
                            }
                        }
                        options={{
                            scales: {
                                y: {
                                    min: Math.min(...amountOfTables) - 1
                                },
                                x: {
                                    display: false
                                }
                            }
                        }}
                    />
                </div>
                <div className="flex-item">
                    <div className="display-flex-row">
                        <b>Size of the database (Gigabytes)</b>
                        <Button onClick={() => handleButtonClick("databaseSizeBytes")}>Details</Button>
                    </div>
                    <Line
                        data={
                            {
                                labels: [...labels],
                                datasets: [
                                    {
                                        label: 'Size of database',
                                        backgroundColor: '#18145c',
                                        borderColor: '#18145c',
                                        borderWidth: 1,
                                        data: [...(sizeOfDatabase.map(size => size / (1024 * 1024 * 1024)))]
                                    },
                                ],
                            }
                        }
                        options={{
                            scales: {
                                y: {
                                    min: Math.min(...(sizeOfDatabase.map(size => size / (1024 * 1024 * 1024)))) - 0.01
                                },
                                x: {
                                    display: false
                                }

                            }
                        }}
                    />
                </div>
            </div>
            <div className="display-flex-row margin-bottom-30">
                <div className="display-flex-row margin-bottom-30">
                    <div className="flex-item">
                        <div className="display-flex-row padding-right-15">
                            <b>Total amount of Groupcodes</b>
                            <Button onClick={() => handleButtonClick("groupCodesCount")}>Details</Button>
                        </div>
                        <Line
                            data={
                                {
                                    labels: [...labels],
                                    datasets: [
                                        {
                                            label: 'Number of groupcodes',
                                            backgroundColor: '#18145c',
                                            borderColor: '#18145c',
                                            borderWidth: 1,
                                            data: [...numberOfGroupCodes]
                                        },
                                    ],
                                }
                            }
                            options={{
                                scales: {
                                    y: {
                                        min: Math.min(...numberOfGroupCodes) - 1
                                    },
                                    x: {
                                        display: false
                                    }
                                }
                            }}
                        />
                    </div>
                    <div className="flex-item">
                        <div className="display-flex-row">
                            <b>Total amount of Entities</b>
                            <Button onClick={() => handleButtonClick("entitiesCount")}>Details</Button>
                        </div>
                        <Line
                            data={
                                {
                                    labels: [...labels],
                                    datasets: [
                                        {
                                            label: 'Number of entities',
                                            backgroundColor: '#18145c',
                                            borderColor: '#18145c',
                                            borderWidth: 1,
                                            data: [...numberOfEntities]
                                        },
                                    ],
                                }
                            }
                            options={{
                                scales: {
                                    y: {
                                        min: Math.min(...numberOfEntities) - 1
                                    },
                                    x: {
                                        display: false
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>


            <div className="display-flex-row margin-bottom-30">
                <div className="flex-item">
                    <div className="display-flex-row padding-right-15">
                        <b>Total amount of active users</b>
                        <Button onClick={() => handleButtonClick("activeUsersCount")}>Details</Button>
                    </div>
                    <Line
                        data={
                            {
                                labels: [...labels],
                                datasets: [
                                    {
                                        label: 'Number of active users',
                                        backgroundColor: '#18145c',
                                        borderColor: '#18145c',
                                        borderWidth: 1,
                                        data: [...activeUsersCount]
                                    },
                                ],
                            }
                        }
                        options={{
                            scales: {
                                y: {
                                    min: Math.min(...activeUsersCount) > 1 ? Math.min(...activeUsersCount) - 1 : Math.min(...activeUsersCount)
                                },
                                x: {
                                    display: false
                                }
                            }
                        }}
                    />
                </div>
                <div className="flex-item">
                    <div className="display-flex-row">
                        <b>Total amount of Environments</b>
                        <Button onClick={() => handleButtonClick("environmentsCount")}>Details</Button>
                    </div>
                    <Line
                        data={
                            {
                                labels: [...labels],
                                datasets: [
                                    {
                                        label: 'Number of environments',
                                        backgroundColor: '#18145c',
                                        borderColor: '#18145c',
                                        borderWidth: 1,
                                        data: [...numberOfEnvironments]
                                    },
                                ],
                            }
                        }
                        options={{
                            scales: {
                                y: {
                                    min: Math.min(...numberOfEnvironments) - 1
                                },
                                x: {
                                    display: false
                                }
                            }
                        }}
                    />
                </div>
            </div>

            <div className="display-flex-row margin-bottom-30">
                <div className="flex-item">
                    <div className="display-flex-row padding-right-15">
                        <b>Duration of SP executions (seconds)</b>
                        <Button onClick={() => handleButtonClick("queryExecutionsCount")}>Details</Button>
                    </div>
                    <Line
                        data={
                            {
                                labels: [...labels],
                                datasets: [
                                    {
                                        label: 'Number of executions',
                                        backgroundColor: '#18145c',
                                        borderColor: '#18145c',
                                        borderWidth: 1,
                                        data: [...numberOfExecutions.map(execution => execution / 1000)]
                                    },
                                ],
                            }
                        }
                        options={{
                            scales: {
                                y: {
                                    min: Math.min(...numberOfExecutions) > 1 ? Math.min(...numberOfExecutions) - 1 : Math.min(...numberOfExecutions)
                                },
                                x: {
                                    display: false
                                }
                            }
                        }}
                    />
                </div>
                <div className="flex-item">
                    <div className="display-flex-row">
                        <b>Duration of logical read and writes (seconds) </b>
                        <Button onClick={() => handleButtonClick("totalLogicalWrites")}>Details</Button>
                    </div>
                    <Line
                        data={
                            {
                                labels: [...labels],
                                datasets: [
                                    {
                                        label: 'Number of read and writes',
                                        backgroundColor: '#18145c',
                                        borderColor: '#18145c',
                                        borderWidth: 1,
                                        data: [...numberOfLogicalReadWrites.map(reads => reads / 1000)]
                                    },
                                ],
                            }
                        }
                        options={{
                            scales: {
                                y: {
                                    min: Math.min(...numberOfLogicalReadWrites) > 1 ? Math.min(...numberOfLogicalReadWrites) - 1 : Math.min(...numberOfLogicalReadWrites)
                                },
                                x: {
                                    display: false
                                }
                            }
                        }}
                    />
                </div>
            </div>
            <div className="display-flex-row margin-bottom-30">
                <div className="flex-item">
                    <div className="display-flex-row padding-right-15">
                        <b>CPU processing time (seconds)</b>
                        <Button onClick={() => handleButtonClick("totalCpuTimeMs")}>Details</Button>
                    </div>
                    <Line
                        data={
                            {
                                labels: [...labels],
                                datasets: [
                                    {
                                        label: 'CPU time',
                                        backgroundColor: '#18145c',
                                        borderColor: '#18145c',
                                        borderWidth: 1,
                                        data: [...cpuTime.map(cpu => cpu / 1000)]
                                    },
                                ],
                            }
                        }
                        options={{
                            scales: {
                                y: {
                                    min: Math.min(...cpuTime) > 1 ? Math.min(...cpuTime) - 1 : Math.min(...cpuTime)
                                },
                                x: {
                                    display: false
                                }
                            }
                        }}
                    />
                </div>
                <div className="flex-item">
                    <div className="display-flex-row">
                        <b>Duration of a query (seconds)</b>
                        <Button onClick={() => handleButtonClick("totalElapsedTimeMs")}>Details</Button>
                    </div>
                    <Line
                        data={
                            {
                                labels: [...labels],
                                datasets: [
                                    {
                                        label: 'Duration',
                                        backgroundColor: '#18145c',
                                        borderColor: '#18145c',
                                        borderWidth: 1,
                                        data: [...duration.map(duration => duration / 1000)]
                                    },
                                ],
                            }
                        }
                        options={{
                            scales: {
                                y: {
                                    min: Math.min(...duration) > 1 ? Math.min(...duration) - 1 : Math.min(...duration)
                                },
                                x: {
                                    display: false
                                }
                            }
                        }}
                    />
                </div>
            </div>
            <div className="flex-item">
                <div className="display-flex-row padding-right-15">
                    <b>Total amount of Batch processing jobs</b>
                    <Button onClick={() => handleButtonClick("batchProcessingJobsCount")}>Details</Button>
                </div>
                <Line
                    data={
                        {
                            labels: [...labels],
                            datasets: [
                                {
                                    label: 'Amount of batch processing',
                                    backgroundColor: '#18145c',
                                    borderColor: '#18145c',
                                    borderWidth: 1,
                                    data: [...amountOfBatchProcessing]
                                },
                            ],
                        }
                    }
                    options={{
                        scales: {
                            y: {
                                min: Math.min(...amountOfBatchProcessing) - 1
                            },
                            x: {
                                display: false
                            }
                        }
                    }}
                />
            </div>
            <Drawer
                width={"400px"}
                getContainer={false}
                style={{ position: "absolute" }}
                title={"Details"}
                placement={DRAWER_PLACEMENTS.BOTTOM}
                onClose={onClose}
                visible={openDrawer}
                closable={false}
                height={"450px"}>
                {

                    <Datatable
                        scroll={scroll}
                        tableColumns={columns}
                        data={drawerTable}
                        setData={setDrawerTable}
                        isTableLoading={false}
                        otherActions={[]}
                        otherRowEnabled={false}
                        editRowEnabled={false}
                        copyRowEnabled={true}
                        deleteRowEnabled={false}
                        viewRowEnabled={true}
                        onEditFunc={undefined}
                        onCopyFunc={false}
                        onDeleteFunc={undefined}
                        onViewFunc={openDrawer}
                        onDoubleClickRow={undefined}
                        selectable={false}
                        multiSelect={false}
                        selectedRows={[]}
                        setSelectedRows={undefined}
                        defaultSortColumn={"dateCreated"}
                        defaultSortColumnDirection={"descend"}

                    ></Datatable>

                }
            </Drawer>
        </div>

    )
}
export default Analytics;